export const ADMIN_AFFILIATION_NET = 1000;
export const AGENCY_AFFILIATION_NET = 500;
export const SUPPLIER_AFFILIATION_NET = 500;
export const UTILIZER_AFFILIATION_NET = 500;
export const AFFILIATION_TAX = 22;

export const AdminTypes = [
  'BUILDING_ADMIN_1',
  'BUILDING_ADMIN_2',
  'BUILDING_ADMIN_3',
  'BUILDING_ADMIN_4',
  'BUILDING_ADMIN_5',
];

export const SupplierTypes = ['SUPPLIER'];
export const AgencyTypes = ['AGENCY'];

export const ProfileTypes = [
  ...AdminTypes,
  ...SupplierTypes,
  'SUPPLIER_INS',
  'COMMERCIAL',
  'AGENCY',
  'GENERIC_CUSTOMER',
  'EON_ENERGY',
  'CERTIFIER',
  'LAWYER',
  'UTILIZER',
  'MARKETING',
  'ASSOCIATION',
];

export const PROFILE_TYPE_LABELS = {
  BUILDING_ADMIN_1: 'Amministratore Triangolo',
  BUILDING_ADMIN_2: 'Amministratore Quadrato',
  BUILDING_ADMIN_3: 'Amministratore Pentagono',
  BUILDING_ADMIN_4: 'Amministratore Esagono',
  BUILDING_ADMIN_5: 'Amministratore Ottagono',
  SUPPLIER: 'Fornitore',
  SUPPLIER_INS: 'Assicuratore',
  COMMERCIAL: 'Commerciale',
  AGENCY: 'Agenzia Immobiliare',
  GENERIC_CUSTOMER: 'Cliente Generico',
  EON_ENERGY: 'Fornitore Energia',
  CERTIFIER: 'Certificatore',
  LAWYER: 'Avvocato',
  UTILIZER: 'Utilizzatore',
  ADMIN_COLLAB: 'Collaboratore Admin',
  ASSOCIATION: 'Associazione',
};

export const ProfileStatus = ['ACTIVATED', 'NOT_ACTIVATED'];

export const LAST_MASTER_YEAR = 2022;

export const ACCOUNTABILITY_LIMIT_DATE = '2023-04-01';
export const NUMBER_PAST_YEARS = 5;

export const IAFType = {
  INVOICES: 'INVOICES',
  INSURANCES: 'INSURANCES',
  INVOICES_SUB_ADMINS: 'INVOICES_SUB_ADMINS',
  ENERGY: 'ENERGY',
  RECURRENT_ENERGY: 'RECURRENT_ENERGY',
  SIGNALS: 'SIGNALS',
};

export const EON_PRODUCT_TYPE_LABELS = {
  EON_GAS_CERTO_NEW: 'E.ON GasCerto New',
  EON_GAS_CERTO_PREMIUM_NEW: 'E.ON Gas Certo Premium new',
  EON_DINAMICA_SEMPLICE_PIU: 'E.ON Dinamica semplice più',
  EON_LUCE_MERCATO_EASY: 'E.ON Luce Mercato Easy',
  EON_LUCE_MERCATO_PLUS_EASY: 'E.ON Luce Mercato Plus Easy',
  EON_LUCE_MERCATO_PLUS_PREMIUM: 'E.ON Luce Mercato Plus Premium',
  DUFERCO_GAS_VENERE: 'Duferco Gas Venere',
  DUFERCO_GAS_GIOVE: 'Duferco Gas Giove',
  DUFERCO_GAS_NETTUNO: 'Duferco Gas Nettuno',
  DUFERCO_GAS_MARTE: 'Duferco Gas Marte',
  INDEX_BUSINESS_SCONTO_6: 'Index Business Sconto 6',
  INDEX_BUSINESS_SCONTO_2: 'Index Business Sconto 2',
  DUFERCO_LUCE_VENERE: 'Duferco Luce Venere',
  DUFERCO_LUCE_SATURNO: 'Duferco Luce Saturno',
  DUFERCO_LUCE_NETTUNO: 'Duferco Luce Nettuno',
  DUFERCO_LUCE_MARTE: 'Duferco Luce Marte',
  DUFERCO_RES_LIBERTA_PER_TE_LUCE: 'Duferco Res Liberta Per Te Luce',
  DUFERCO_RES_PIANETA_BLU_LUCE: 'Duferco Res Pianeta Blu Luce',
  DUFERCO_RES_LIBERTA_PER_TE_GAS: 'Duferco Res Liberta Per Te Gas',
  DUFERCO_RES_PIANETA_BLU_GAS: 'Duferco Res Pianeta Blu Gas',
  DUF_ENTRY_LUCE: 'Duf Entry Luce',
  DUF_VIVACE_LUCE: 'Duf Vivace Luce',
  DUF_ALLEGRO_LUCE: 'Duf Allegro Luce',
  DUF_ANDANTE_LUCE: 'Duf Andante Luce',
  DUF_ADAGIO_LUCE: 'Duf Adagio Luce',
  DUF_ENTRY_GAS: 'Duf Entry Gas',
  DUF_VIVACE_GAS: 'Duf Vivace Gas',
  DUF_ALLEGRO_GAS: 'Duf Allegro Gas',
  DUF_ANDANTE_GAS: 'Duf Andante Gas',
  DUF_ADAGIO_GAS: 'Duf Adagio Gas',
  DOMESTICO_LUCE: 'Domestico Luce',
  DOMESTICO_GAS: 'Domestico Gas',
  PIVA_LUCE: 'Piva Luce',
  PIVA_GAS: 'Piva Gas',
  GAS_PLATINO_SUPER_BOLLETTA: 'Gas Platino Superbolletta',
  GAS_DIAMANTE: 'Gas Diamante',
  GAS_ORO: 'Gas Oro',
  GAS_ARGENTO: 'Gas Argento',
  EE_PLATINO_SUPER_BOLLETTA: 'E/E Platino Superbolletta',
  EE_DIAMANTE: 'E/E Diamante',
  EE_ORO: 'E/E Oro',
  EE_ARGENTO: 'E/E Argento',
  BERGAMO_GAS_E_LUCE_BASE: 'Bergamo Gas e Luce Base',
  BERGAMO_GAS_E_LUCE_CAT12018: 'Bergamo Gas e Luce CAT 12018',
  BERGAMO_GAS_E_LUCE_CAT15014: 'Bergamo Gas e Luce CAT 15014',
  BERGAMO_GAS_E_LUCE_GAS_BASE: 'Bergamo Gas e Luce Gas Base',
  BERGAMO_GAS_E_LUCE_CATGN1214: 'Bergamo Gas e Luce CAT 1214',
  BERGAMO_GAS_E_LUCE_CATGN1512: 'Bergamo Gas e Luce CAT 1512',
  ADAPTA_CASA_SICURA: 'Adapta Casa Sicura',
  ADAPTA_CASA_DINAMICA: 'Adapta Casa Dinamica',
  ADAPTA_CASA_UNICA: 'Adapta Casa Unica',
  ADAPTA_CASA_CONV: 'Adapta Casa Conv',
  ADAPTA_BUSINESS_ESSENZIALE: 'Adapta Business Essenziale',
  ADAPTA_BUSINESS_CONV: 'Adapta Business Conv',
  ADAPTA_BUSINESS_SICURA: 'Adapta Business Sicura',
  ADAPTA_BUSINESS_DINAMICA: 'Adapta Business Dinamica',
  ADAPTA_BUSINESS_UNICA: 'Adapta Business Unica',
  ADAPTA_BUSINESS_PIU: 'Adapta Business Piu',
  ADPT100: 'ADPT100',
  ADPT90: 'ADPT90',
  ADPT80: 'ADPT80',
  ADPT70: 'ADPT70',
  ADPT60: 'ADPT60',
  ADPT50: 'ADPT50',
  ADPT40: 'ADPT40',
  ADPT30: 'ADPT30',
  ADPT20: 'ADPT20',
  ADPT10: 'ADPT10',
  CASASICURA: 'Casa Sicura',
  CASAUNICA: 'Casa Unica',
  CASADINAMICA: 'Casa Dinamica',
  CASA_CONV80: 'Casa Conv80',
  CASA_CONV70: 'Casa Conv70',
  TARIFFA_CONSUMI_ALTI: 'Tariffa Consumi Alti',
  GEOFLEX_BUSINESS_CONV90: 'Geoflex Business Conv90',
  GEOFLEX_BUSINESS_CONV80: 'Geoflex Business Conv80',
  GEOFLEX_BUSINESS_ESSENZIALE: 'Geoflex Business Essenziale',
  GEOFLEX_BUSINESS_CERTA: 'Geoflex Business Certa',
  GEOFLEX_BUSINESS_SICURA: 'Geoflex Business Sicura',
  GEOFLEX_BUSINESS_DINAMICA: 'Geoflex Business Dinamica',
  GEOFLEX_COND_115: 'Geoflex Cond 115',
  GEOFLEX_COND_105: 'Geoflex Cond 105',
  GEOFLEX_COND_95: 'Geoflex Cond 95',
  GEOFLEX_COND_85: 'Geoflex Cond 85',
  GEOFLEX_COND_75: 'Geoflex Cond 75',
  GEOFLEX_COND_65: 'Geoflex Cond 65',
  GEOFLEX_COND_55: 'Geoflex Cond 55',
  GEOFLEX_COND_45: 'Geoflex Cond 45',
  GEOFLEX_COND_35: 'Geoflex Cond 35',
  GEOFLEX_COND_25: 'Geoflex Cond 25',
  GEOFLEX_COND_15: 'Geoflex Cond 15',
  DOMESTICO_EXTRA_EE_0: 'Domestico Extra E.E. 0',
  DOMESTICO_EXTRA_EE_1: 'Domestico Extra E.E. 1',
  DOMESTICO_EXTRA_EE_2: 'Domestico Extra E.E. 2',
  DOMESTICO_EXTRA_EE_3: 'Domestico Extra E.E. 3',
  DOMESTICO_EXTRA_EE_4: 'Domestico Extra E.E. 4',
  BUSINESS_EXTRA_EE_1: 'Business Extra E.E. 1',
  BUSINESS_EXTRA_EE_2: 'Business Extra E.E. 2',
  BUSINESS_EXTRA_EE_3: 'Business Extra E.E. 3',
  BUSINESS_EXTRA_EE_4: 'Business Extra E.E. 4',
  ALTO_VALORE_7_15_EE: 'Alto Valore 7.15 E.E.',
  ALTO_VALORE_8_20_EE: 'Alto Valore 8.20 E.E.',
  ALTO_VALORE_9_30_EE: 'Alto Valore 9.30 E.E.',
  ALTO_VALORE_10_35_EE: 'Alto Valore 10.35 E.E.',
  CONDOMINIO_EXTRA_EE_1: 'Condominio Extra E.E. 1',
  CONDOMINIO_EXTRA_EE_2: 'Condominio Extra E.E. 2',
  CONDOMINIO_EXTRA_EE_3: 'Condominio Extra E.E. 3',
  CONDOMINIO_EXTRA_EE_4: 'Condominio Extra E.E. 4',
  CONDOMINIO_EXTRA_EE_5: 'Condominio Extra E.E. 5',
  CONDOMINIO_EXTRA_EE_6: 'Condominio Extra E.E. 6',
  CONDOMINIO_EXTRA_EE_7: 'Condominio Extra E.E. 7',
  CONDOMINIO_EXTRA_EE_8: 'Condominio Extra E.E. 8',
  CONDOMINIO_EXTRA_EE_9: 'Condominio Extra E.E. 9',
  CONDOMINIO_EXTRA_EE_10: 'Condominio Extra E.E. 10',
  DOMESTICO_EXTRA_GAS_0: 'Domestico Extra Gas 0',
  DOMESTICO_EXTRA_GAS_1: 'Domestico Extra Gas 1',
  DOMESTICO_EXTRA_GAS_2: 'Domestico Extra Gas 2',
  DOMESTICO_EXTRA_GAS_3: 'Domestico Extra Gas 3',
  DOMESTICO_EXTRA_GAS_4: 'Domestico Extra Gas 4',
  BUSINESS_EXTRA_GAS_1: 'Business Extra Gas 1',
  BUSINESS_EXTRA_GAS_2: 'Business Extra Gas 2',
  BUSINESS_EXTRA_GAS_3: 'Business Extra Gas 3',
  BUSINESS_EXTRA_GAS_4: 'Business Extra Gas 4',
  ALTO_VALORE_7_15_GAS: 'Alto Valore 7.15 Gas',
  ALTO_VALORE_8_20_GAS: 'Alto Valore 8.20 Gas',
  ALTO_VALORE_9_30_GAS: 'Alto Valore 9.30 Gas',
  ALTO_VALORE_10_35_GAS: 'Alto Valore 10.35 Gas',
  CONDOMINIO_EXTRA_GAS_1: 'Condominio Extra Gas 1',
  CONDOMINIO_EXTRA_GAS_2: 'Condominio Extra Gas 2',
  CONDOMINIO_EXTRA_GAS_3: 'Condominio Extra Gas 3',
  CONDOMINIO_EXTRA_GAS_4: 'Condominio Extra Gas 4',
  CONDOMINIO_EXTRA_GAS_5: 'Condominio Extra Gas 5',
  CONDOMINIO_EXTRA_GAS_6: 'Condominio Extra Gas 6',
  CONDOMINIO_EXTRA_GAS_7: 'Condominio Extra Gas 7',
  CONDOMINIO_EXTRA_GAS_8: 'Condominio Extra Gas 8',
  CONDOMINIO_EXTRA_GAS_9: 'Condominio Extra Gas 9',
  CONDOMINIO_EXTRA_GAS_10: 'Condominio Extra Gas 10',
  CONDOMINIO_EXTRA_GAS_11: 'Condominio Extra Gas 11',
};

export const ENERGY_CONTRACT_VARIABLES = [
  'ALTO_VALORE_7_15_EE',
  'ALTO_VALORE_8_20_EE',
  'ALTO_VALORE_9_30_EE',
  'ALTO_VALORE_10_35_EE',
  'ALTO_VALORE_7_15_GAS',
  'ALTO_VALORE_8_20_GAS',
  'ALTO_VALORE_9_30_GAS',
  'ALTO_VALORE_10_35_GAS',
  'CONDOMINIO_EXTRA_EE_1',
  'CONDOMINIO_EXTRA_EE_2',
  'CONDOMINIO_EXTRA_EE_3',
  'CONDOMINIO_EXTRA_EE_4',
  'CONDOMINIO_EXTRA_EE_5',
  'CONDOMINIO_EXTRA_EE_6',
  'CONDOMINIO_EXTRA_EE_7',
  'CONDOMINIO_EXTRA_EE_8',
  'CONDOMINIO_EXTRA_EE_9',
  'CONDOMINIO_EXTRA_EE_10',
  'CONDOMINIO_EXTRA_GAS_1',
  'CONDOMINIO_EXTRA_GAS_2',
  'CONDOMINIO_EXTRA_GAS_3',
  'CONDOMINIO_EXTRA_GAS_4',
  'CONDOMINIO_EXTRA_GAS_5',
  'CONDOMINIO_EXTRA_GAS_6',
  'CONDOMINIO_EXTRA_GAS_7',
  'CONDOMINIO_EXTRA_GAS_8',
  'CONDOMINIO_EXTRA_GAS_9',
  'CONDOMINIO_EXTRA_GAS_10',
  'CONDOMINIO_EXTRA_GAS_11',
];
